module.exports = "/public/images/4112b5baffbfac77d3daa378ee4be98f.svg";